import apiClient from "./index";

export const findAllByLoginPolicy = () => {
    return apiClient.post(`/admin/loginPolicy/getLoginPolicy.json`);
}

export const saveByLoginPolicy = loginPolicy => {
    return apiClient.post(`/admin/loginPolicy/saveLoginPolicy.json`, loginPolicy);
}

export const findAllByLoginMode = () => {
    return apiClient.post(`/admin/loginPolicy/getLoginMode.json`);
}

export const saveByLoginMode = loginMode => {
    return apiClient.post(`/admin/loginPolicy/saveLoginMode.json`, loginMode);
}

export const findAllBy2ndAuth = () => {
    return apiClient.post(`/admin/loginPolicy/findByEmail2ndAuth.json`);
}

export const saveBy2ndAuth = email2ndAuth => {
    return apiClient.post(`/admin/loginPolicy/saveEmail2ndAuth.json`, email2ndAuth);
}

export const findAllByStorageMode = () => {
    return apiClient.post(`/admin/loginPolicy/findByStorageMode.json`);
}

export const saveByStorageMode = storageMode => {
    return apiClient.post(`/admin/loginPolicy/saveStorageMode.json`, storageMode);
}

// 소셜 로그인 사용 여부 조회
export function getSocialLoginEnabled() {
  return apiClient.post('/admin/loginPolicy/getSocialLoginEnabled.json');
}

// 소셜 로그인 설정 저장
export function saveSocialLogin(data) {
  return apiClient.post('/admin/loginPolicy/saveSocialLogin.json', data);
}

/** 초기 세팅용 */
export const getLoginMode = () => {
    return apiClient.post(`/sys/loginPolicy/getLoginMode.json`);
}

export const getStorageMode = () => {
    return apiClient.post(`/sys/loginPolicy/findByStorageMode.json`);
}

//로그인 화면용 (사용 중인 것만)
export const getEnabledSocialLogin = () => {
    return apiClient.post(`/sys/loginPolicy/getEnabledSocialLogin.json`);
}